import React, { useEffect, useRef, useState } from "react";
import "./styles.css"; // Create this CSS file for styles
import arrow from "../../../public/assets/icon/Outlined_arrow-right.svg";


const CustomSelect = ({ className, value, placeholder, label, options, onSelect }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    id: null,
    label: null,
  });

  const hoverTargetRef = useRef(null);
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleClickOutside = (event) => {
    if (
      hoverTargetRef.current &&
      !hoverTargetRef.current.contains(event.target)
    ) {
      setIsHovered(false);
    }
  };

  const handleSetSelectedOption = (option) => {
    setIsHovered(false);
    setSelectedOption(option);
    onSelect && onSelect(option);
  };

  const isSelected = (option) => {

    return selectedOption && option.id === selectedOption.id && "selected-item";
  };

  const getselectContainerClasess = className
    ? `select-container ${className}`
    : "select-container";
  const selectedOptionClasess = !label
    ? "selected-option-content no-labrl"
    : "selected-option-content";

  return (
    <div className={getselectContainerClasess} ref={hoverTargetRef}>
      <div className="selected-option" onMouseOver={handleMouseOver}>
        <div className={selectedOptionClasess}>
          {label && <label className="selected-option-label">{label}</label>}
          <span>{value?.label || placeholder }</span>
        </div>
        <img src={arrow} className="falg-arrow" />
      </div>
      {isHovered && (
        <div className="select-options">
          {options &&
            options.map((option) => (
              <div
                onClick={() => handleSetSelectedOption(option)}
                key={option.id}
                value={option.id}
                className={`item-option ${isSelected(option)}`}
              >
                {option.label}
                {option.subText && <span>{option.subText}</span>}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export { CustomSelect };
